import { ValueOf } from '../types/common';

// Valid panel types for VideoPanel component
export const VideoPanelTypes = {
  DETAILS: 'DETAILS',
  PICKER: 'PICKER',
} as const;

export type VideoPanelType = ValueOf<typeof VideoPanelTypes>;

export const PanelTypes = {
  ...VideoPanelTypes,
  CLIP_EDITOR: 'CLIP_EDITOR',
} as const;

export type PanelType = ValueOf<typeof PanelTypes>;

export const DetailsTabs = {
  OPTIMIZATION: 'OPTIMIZATION',
  PERFORMANCE: 'PERFORMANCE',
  CAPTIONS: 'CAPTIONS',
  DETAILS: 'DETAILS',
  VARIANTS: 'VARIANTS',
} as const;

export type DetailsTab = ValueOf<typeof DetailsTabs>;
